module.exports = __webpack_public_path__ + "img/expostyle_0963_anthracite.002255e4.jpg";